import BabyElephant from '../assets/photos/BabyElephant.jpg'
import ChinaTree from '../assets/photos/ChinaTree.jpg'
import ColoredWater from '../assets/photos/ColoredWater.jpg'
import Crab from '../assets/photos/Crab.jpg'
import Dolphins from '../assets/photos/Dolphins.jpg'
import Elephant from '../assets/photos/Elephant.jpg'
import FarmMountain from '../assets/photos/FarmMountain.jpg'
import GreatWall from '../assets/photos/GreatWAll.jpg'
import GreenyBits from '../assets/photos/GreenyBits.jpg'
import Grizzly from '../assets/photos/Grizzly.jpg'
import IslandInSand from '../assets/photos/IslandInSand.jpg'
import Montezuma from '../assets/photos/Montezuma.jpg'
import MoodySky from '../assets/photos/MoodySky.JPG'
import MtCook from '../assets/photos/MtCook.jpg'
import MtDoomMe from '../assets/photos/MtDoomMe.jpg'
import MtDoomPaddock from '../assets/photos/MtDoomPaddock.jpg'
import NotherSunset from '../assets/photos/NotherSunset.jpg'
import Nudi from '../assets/photos/Nudi.jpg'
import PancakeRocks from '../assets/photos/PancakeRocks.jpg'
import WashBuffalo from '../assets/photos/WashBuffalo.jpg'
import WaterFallCR from '../assets/photos/WaterFallCR.jpg'
import WhaleShark from '../assets/photos/WhaleShark.jpg'

export const pictures = [
    {
        url: BabyElephant,
        altTag: 'Baby Elephant',
        description: 'Four month old elephant in Chiang Mai, Thailand.',
    },
    {
        url: ChinaTree,
        altTag: 'Tree',
        description: 'One of my favorite sets of trees!',
    },
    {
        url: ColoredWater,
        altTag: 'Colored Hot Springs',
        description: 'Hot Springs in Rotorua, NZ',
    },
    {
        url: Crab,
        altTag: 'Crab',
        description: 'Tide pool exploring, Waiheke, NZ',
    },
    {
        url: Dolphins,
        altTag: 'Dolphins in Water',
        description: 'Dolphins near The Poor Knights Island',
    },
    {
        url: Elephant,
        altTag: 'Elephant',
        description: 'She got a whiff of some fruit in my bag!',
    },
    {
        url: FarmMountain,
        altTag: 'Mountain Backdrop',
        description: 'Beautiful views on a roadtrip.',
    },
    {
        url: GreatWall,
        altTag: 'Great Wall of China',
        description: 'Hiked about 6 hours along The Great Wall.',
    },
    {
        url: GreenyBits,
        altTag: 'Small Green Plants',
        description: '',
    },
    {
        url: Grizzly,
        altTag: 'Grizzly Bear',
        description: 'Grizzly Bear in Hoonah, Alaska',
    },
    {
        url: IslandInSand,
        altTag: 'Small Tree Growing on Beach',
        description: 'Abel Tasman National Park',
    },
    {
        url: Montezuma,
        altTag: 'Beaches of Montezuma',
        description: 'Beach in Montezuma, Costa Rica',
    },
    {
        url: MoodySky,
        altTag: 'Blackend Skies',
        description: 'Snow Shoeing in the Rockies',
    },
    {
        url: MtCook,
        altTag: 'Mount Cook',
        description: 'Mount Cook',
    },
    {
        url: MtDoomMe,
        altTag: 'Mount Doom',
        description: 'Mount Doom!!!',
    },
    {
        url: MtDoomPaddock,
        altTag: 'Mount Doom from a distance',
        description: 'Camping before ascending Mount Doom',
    },
    {
        url: NotherSunset,
        altTag: 'Sunset',
        description: 'Sunset in Queensland',
    },
    {
        url: Nudi,
        altTag: 'Nudi Branch',
        description: 'Baby Nudi Branch in the tide pools.',
    },
    {
        url: PancakeRocks,
        altTag: 'Pancake Rocks',
        description: 'Punakaiki, Pancake Rocks!',
    },
    {
        url: WashBuffalo,
        altTag: 'Women Washing Buffalo',
        description: 'Buffalo cooling down in Vietnam.',
    },
    {
        url: WaterFallCR,
        altTag: 'Flooding Waterfall',
        description: 'Got lucky and caught this waterfall shortly after a flood.',
    },
    {
        url: WhaleShark,
        altTag: 'Whale Shark',
        description: 'First Whale Shark I ever dove with.',
    },

]